import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = ["name", "value", "disabled", "checked", "tabindex"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _createElementVNode("input", _mergeProps({
        name: _ctx.name,
        value: _ctx.value,
        disabled: _ctx.disabled,
        checked: _ctx.checked,
        tabindex: _ctx.tabindex,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event))),
        type: "checkbox"
      }, _ctx.$attrs), null, 16, _hoisted_2),
      _hoisted_3,
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}